module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"submitted":"Thanks for your feedback!"},"ar":{"submitted":"شكراً على ابداء رأيك"}}')
  delete Component.options._Ctor
}
